export const handleChangeDataModalEditPersonalInfo = (name, value) => ({
    type: 'CHANGE_DATA_MODAL_EDIT_PERSONAL_INFO', name, value
});